import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import SkillsProgress from '../../components/skills-progress';

class ProblemSolvingStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      progressValue: 0
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();
    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];
    const lastSurveyId =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1].id
        : 0;

    if (!lastSurveyId) {
      return this.setState({
        loaded: true
      });
    }

    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${lastSurveyId}/`
    ).then(res => {
      const surveyScore = res.body;
      const userScoreQuestions = surveyScore.user_score_question || [];

      const neededQuestion = userScoreQuestions.find(i => i.question === 'Conflict Management');
      const progressValue = neededQuestion ? neededQuestion.median : 0;

      this.setState({
        loaded: true,
        progressValue
      });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      progressValue
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Your Problem Solving | Conflict Management Skills Rating</Title>
        <SkillsProgress
          title="Conflict Management"
          progressValue={progressValue}
        />
        <Text>
          <p>Having conflicts within a team is very common and at times often encouraged to help teams perform better (<a href="https://hbr.org/2012/07/conflict-keeps-teams-at-the-to" target="_blank" rel="noreferrer">HBS article</a>). However, conflicts can be destructive if not managed properly. It’s why the ability to manage and de-escalate conflicts is one of the most invaluable and highly desirable skill that employers seek.<br /><br /></p>
          <p>If you’re treating conflict as a mutual problem and work with other team members to better understand their point of view, then you’re demonstrating very strong and highly desirable conflict management skills.<br /><br /></p>
          <p>On the flip side, if you’re treating conflict as a win-lose contest, then you’re demonstrating very low levels of analytical skills.<br /><br /></p>
          <p><a href="https://www.cnbc.com/2022/10/13/ryan-reynolds-credits-his-success-to-one-skill-it-changed-my-life.html" target="_blank" rel="noreferrer">Ryan Reynolds reveal the No. 1 skill that helps him succeed.</a></p>
        </Text>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ProblemSolvingStep2;




// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/problem-solving-step2.js